<template>
  <div id="details">
    <b-modal :active.sync="loader.isLoading" :can-cancel="[false, false, false]">
      <div id="loading">
        <clip-loader
          class="prompt-loader"
          :loading="loader.isLoading"
          color="#949494"
          size="100px"
        ></clip-loader>
        <b class="prompt-header"> <br />{{ loader.currentStep }} </b>
      </div>
    </b-modal>

    <b-modal :active.sync="howItWorksModal" scroll="keep" key="howItWorkModal">
      <div class="card">
        <button class="modal-close-button" @click="howItWorksModal = false">
          &#9932;
        </button>
        <div class="card-content">
          <h2 class="price-heading">How it works</h2>

          <ul class="square-list mt-24">
            <li>
              Select if you would like to redeem Rewards points towards the cost of your
              transaction.
            </li>
            <li>
              If yes, you may choose to redeem points towards 50% or 100% of the total
              booking amount.
            </li>
            <li>
              If you do not have sufficient points given your selection, the maximum
              amount in increments of 5000 points will be redeemed. 5000 points = R250.
            </li>
            <li>
              First, your booking must be settled in full using your Investec Visa card.
            </li>
            <li>
              Your Rewards redemption rebate will then reflect as a credit in your
              Investec Private Bank Account within 48-72 business hours.
            </li>
          </ul>
          <div class="modal-divider mt-24"></div>
          <div class="modal-close-container">
            <div @click="howItWorksModal = false" class="close-button">Ok</div>
          </div>
        </div>
      </div>
    </b-modal>

    <inclusionsModal
      :currentIndex="currentIndex"
      :inclusionsModal.sync="inclusionsModal"
      :rateType="selectedCar.rateType"
      :standardExcludedProps="standardExcludedProps"
      :superExcludedProps="superExcludedProps"
      :onewayFeePrompt="onewayFeePrompt"
      @update:inclusionsModal="inclusionsModal = $event"
      :listingDetails="selectedCar"
    />

    <rentalConditionsModal
      :currentIndex="currentIndex"
      :rentalConditionsModal.sync="rentalConditionsModal"
    />

    <div class="form-errors">
      <!-- <div v-if="errors.length" class="margin-bottom">
        <b class="is-danger">Please correct the following error(s):</b>
        <ul style="margin-top: 8px">
          <li v-for="error in errors" :key="error">{{ error }}</li>
        </ul>
      </div> -->
      <div style="width: 100%">
        <b class="breakdown-heading">Booking review</b>
        <div class="price-wrapper" v-if="isPriceExpanded">
          <!-- Pricing section -->
          <div class="pair pair-flex mt-24">
            <span class="key">Rental price:</span>
            <span class="value value-right"
              >R{{
                formattedPrice(Math.ceil(selectedCar.totalPrice * selectedCar.totalDays))
              }}</span
            >
          </div>
          <div class="pair pair-flex">
            <span class="key">Extras:</span>
            <span class="value value-right"
              >R{{ formattedPrice(Math.ceil(selectedCar.totalExtrasPrice)) }}</span
            >
          </div>
          <div class="pair pair-flex" v-if="selectedCar.onewayFee <= 0">
            <span class="key">Admin fee:</span>
            <span class="value value-right">R{{ formattedPrice(selectedCar.adminFee) }}</span>
          </div>
          <div v-if="selectedCar.onewayFee > 0">
            <div class="pair pair-flex" v-if="selectedCar.adminFee > 0">
              <span class="key">Contract fee:</span>
              <span class="value value-right">R{{ formattedPrice(selectedCar.adminFee) }}</span>
            </div>
            <div class="pair pair-flex">
              <span class="key">One-way fee:</span>
              <span class="value value-right">R{{ formattedPrice(selectedCar.onewayFee) }}</span>
            </div>
          </div>
          <div class="pair pair-flex">
            <span class="key totals">Total price:</span>
            <span class="value value-right totals">R{{ formattedPrice(Math.ceil(selectedCar.price)) }}</span>
          </div>
          
          <!-- Separator line -->
          <div class="review-divider mt-24"></div>
          
          <!-- Car details section -->
          <div class="pair mt-24">
            <span class="key">Rate type:</span>
            <span class="value"><strong>{{ getRateTypeWithMileage }}</strong></span>
          </div>
          <div class="pair">
            <span class="key">Car type:</span>
            <span class="value"><strong>{{ selectedCar.name }} (or similar)</strong></span>
          </div>
          <div class="pair">
            <span class="key">Transmission type:</span>
            <span class="value"><strong>{{ selectedCar.automatic ? 'Automatic' : 'Manual' }}</strong></span>
          </div>
          
          
          <!-- Pickup/Dropoff dates and times -->
          <div class="pair mt-24">
            <span class="key">Pick-up date:</span>
            <span class="value value-nowrap"><strong>{{ formatPickupDate }}</strong></span>
          </div>
          <div class="pair">
            <span class="key">Pick-up time:</span>
            <span class="value value-nowrap"><strong>{{ formatPickupTime }}</strong></span>
          </div>
          <div class="pair">
            <span class="key">Drop-off date:</span>
            <span class="value value-nowrap"><strong>{{ formatDropoffDate }}</strong></span>
          </div>
          <div class="pair">
            <span class="key">Drop-off time:</span>
            <span class="value value-nowrap"><strong>{{ formatDropoffTime }}</strong></span>
          </div>
          
          <!-- Pickup/Dropoff locations -->
          <div class="pair mt-24">
            <span class="key">Pick-up location:</span>
            <span class="value"><strong>{{ formatPickupLocation }}</strong></span>
          </div>
          <div class="pair">
            <span class="key">Drop-off location:</span>
            <span class="value"><strong>{{ formatDropoffLocation }}</strong></span>
          </div>
          
          <!-- Separator line -->
          <div class="review-divider mt-24"></div>
          
          <!-- Back to search button -->
          <div class="mt-24">
            <b-button class="back-to-search-button" @click="backToSearch">
              Back to search
            </b-button>
          </div>
        </div>
        <!--View more / less button-->
        <div class="mobile-only">
          <b-button class="custom-button" @click="isPriceExpanded = !isPriceExpanded"
            >view {{ !isPriceExpanded ? "more" : "less" }}</b-button
          >
        </div>
      </div>
    </div>

    <transition name="rotate-in">
      <form v-if="block == 1">
        <div class="block-contents">
          <h2 class="block-heading">Driver details</h2>
          <div class="mt-24 flex-row gap-25 title-and-initials">
            <CustomDetailsSelect
              class="max-w-120"
              v-model="driver.title"
              placeholder="Title"
              :options="titleOptions"
              type="country"
              :class="{ 'is-error': driver.errors.title }"
            />
            <CustomDetailsInput
              v-model="driver.initials"
              placeholder="Initials"
              :class="{ 'is-error': driver.errors.initials }"
              id="driverInitials"
            />
          </div>
          <CustomDetailsInput
            v-model="driver.firstName"
            placeholder="First name as per ID/passport"
            class="mt-16"
            :class="{ 'is-error': driver.errors.firstName }"
            id="driverFirstName"
          />
          <CustomDetailsInput
            v-model="driver.lastName"
            placeholder="Surname as per ID/passport"
            class="mt-16"
            :class="{ 'is-error': driver.errors.lastName }"
            id="driverLastName"
          />
          <CustomDetailsSelect
            v-model="driver.nationality"
            :options="countrycodes"
            placeholder="Nationality"
            class="mt-16"
            :class="{ 'is-error': driver.errors.nationality }"
            type="country"
            id="driverNationality"
          />
          <div class="mt-16 flex-row gap-25 id-and-id-type">
            <CustomDetailsSelect
              class="max-w-120"
              :class="{ 'is-error': driver.errors.idType }"
              v-model="driver.idType"
              placeholder=""
              :options="idTypeOptions"
              type="id"
            />
            <CustomDetailsInput
              v-model="driver.idNumber"
              :placeholder="driver.idType == 'id' ? 'SA ID' : 'Passport number'"
              :class="{ 'is-error': driver.errors.idNumber }"
              id="driverIdNumber"
            />
          </div>
          <CustomDetailsSelect
            v-model="driver.idIssuingCountry"
            :options="countrycodes"
            placeholder="Country of issue"
            class="mt-16"
            type="country"
            :class="{ 'is-error': driver.errors.idIssuingCountry }"
            id="driverIdIssuingCountry"
          />
          <div class="mt-16 flex-row gap-25 day-and-month-of-birth">
            <CustomDetailsSelect
              v-model="driver.dayOfBirth"
              :options="days"
              placeholder="Day of birth"
              :class="{ 'is-error': driver.errors.dayOfBirth }"
              class="max-w-180"
            />
            <CustomDetailsSelect
              v-model="driver.monthOfBirth"
              :options="months"
              placeholder="Month of birth"
              :class="{ 'is-error': driver.errors.monthOfBirth }"
              class="max-w-180"
            />
            <CustomDetailsSelect
              v-model="driver.yearOfBirth"
              :options="years"
              placeholder="Year of birth"
              type="age"
              :class="{ 'is-error': driver.errors.yearOfBirth }"
            />
          </div>
          <!-- <div class="mt-16">
            <CustomDetailsDatepicker
              :disabled="driver.idType == 'id'"
              v-model="driver.dateOfBirth"
              placeholder="Date of birth"
              class="mt-16"
              type="date"
              :class="{ 'is-error': driver.errors.dateOfBirth }"
            />
          </div> -->
          <CustomDetailsInput
            v-model="driver.email"
            placeholder="Email address"
            class="mt-16"
            type="email"
            :class="{ 'is-error': driver.errors.email }"
            id="driverEmailAddress"
          />
          <CustomDetailsInput
            v-model="driver.mobileNumber"
            placeholder="Mobile number"
            class="mt-16"
            type="tel"
            :class="{ 'is-error': driver.errors.mobileNumber }"
            id="driverMobileNumber"
          />
          <div v-if="!alreadyAdditionalDriver" class="details-segment mt-24 text-bold">
            Will there be an additional driver?
            <div style="display: flex; flex-direction: row; margin-top: 16px">
              <div class="checkbox-row">
                <input
                  type="checkbox"
                  id="yes-checkbox"
                  v-model="isAdditionalDriver"
                  @change="onAdditionalDriver"
                  :class="{ 'is-error': driver.errors.isAdditionalDriver }"
                />
                <span>Yes</span>
              </div>
              <div class="checkbox-row" style="margin-left: 16px">
                <input
                  type="checkbox"
                  id="yes-checkbox"
                  v-model="isNotAdditionalDriver"
                  @change="onNotAdditionalDriver"
                  :class="{ 'is-error': driver.errors.isAdditionalDriver }"
                />
                <span style="padding-left: 8px">No</span>
              </div>
            </div>
          </div>
          <div v-if="isAdditionalDriver || isSecondAdditionalDriver">
            <h2 class="block-heading mt-24">Additional driver details</h2>
            <p class="block-heading-2 mt-24">First additional driver (free)</p>
            <div class="mt-24 flex-row gap-25">
              <CustomDetailsSelect
                class="max-w-120"
                v-model="first_additional_driver.title"
                placeholder="Title"
                :options="titleOptions"
                type="country"
                :class="{ 'is-error': first_additional_driver.errors.title }"
                id="firstAdditionalDriverTitle"
              />
              <CustomDetailsInput
                v-model="first_additional_driver.firstName"
                placeholder="First name as per ID/passport"
                :class="{ 'is-error': first_additional_driver.errors.firstName }"
                id="firstAdditionalDriverFirstName"
              />
            </div>
            <CustomDetailsInput
              v-model="first_additional_driver.lastName"
              placeholder="Surname as per ID/passport"
              class="mt-16"
              :class="{ 'is-error': first_additional_driver.errors.lastName }"
              id="firstAdditionalDriverLastName"
            />
            <div class="mt-16 flex-row gap-25 id-and-id-type">
              <CustomDetailsSelect
                class="max-w-120"
                :class="{ 'is-error': first_additional_driver.errors.idType }"
                v-model="first_additional_driver.idType"
                placeholder=""
                :options="idTypeOptions"
                type="id"
              />
              <CustomDetailsInput
                v-model="first_additional_driver.idNumber"
                :placeholder="
                  first_additional_driver.idType == 'id' ? 'SA ID' : 'Passport number'
                "
                :class="{ 'is-error': first_additional_driver.errors.idNumber }"
                id="firstAdditionalDriverIdNumber"
              />
            </div>
            <div class="mt-16 flex-row gap-25">
              <CustomDetailsSelect
                v-model="first_additional_driver.dayOfBirth"
                :options="days"
                placeholder="Day of birth"
                :class="{ 'is-error': first_additional_driver.errors.dayOfBirth }"
                class="max-w-180"
                id="firstAdditionalDriverDayOfBirth"
              />
              <CustomDetailsSelect
                v-model="first_additional_driver.monthOfBirth"
                :options="months"
                placeholder="Month of birth"
                :class="{ 'is-error': first_additional_driver.errors.monthOfBirth }"
                id="firstAdditionalDriverMonthOfBirth"
                class="max-w-180"
              />
              <CustomDetailsSelect
                v-model="first_additional_driver.yearOfBirth"
                :options="years"
                placeholder="Year of birth"
                type="age"
                :class="{ 'is-error': first_additional_driver.errors.yearOfBirth }"
                id="firstAdditionalDriverYearOfBirth"
              />
            </div>
            <!-- <div class="mt-16">
            <CustomDetailsDatepicker
              v-model="first_additional_driver.dateOfBirth"
              placeholder="Date of birth"
              class="mt-16"
              type="date"
              :class="{ 'is-error': first_additional_driver.errors.dateOfBirth }"
            />
          </div> -->
            <div class="mt-16">
              <CustomDetailsSelect
                v-model="first_additional_driver.gender"
                placeholder="Gender"
                :options="[
                  { name: 'Male', code: 'male' },
                  { name: 'Female', code: 'female' },
                ]"
                type="country"
              />
            </div>

            <div v-if="isSecondAdditionalDriver">
              <p class="block-heading mt-24">Second additional driver details</p>
              <div class="mt-24 flex-row gap-25">
                <CustomDetailsSelect
                  class="max-w-120"
                  v-model="second_additional_driver.title"
                  placeholder="Title"
                  :options="titleOptions"
                  type="country"
                  :class="{ 'is-error': second_additional_driver.errors.title }"
                />
                <CustomDetailsInput
                  v-model="second_additional_driver.firstName"
                  placeholder="First name as per ID/passport"
                  :class="{ 'is-error': second_additional_driver.errors.firstName }"
                />
              </div>
              <CustomDetailsInput
                v-model="second_additional_driver.lastName"
                placeholder="Surname as per ID/passport"
                class="mt-16"
                :class="{ 'is-error': second_additional_driver.errors.lastName }"
              />
              <div class="mt-16 flex-row gap-25 id-and-id-type">
                <CustomDetailsSelect
                  class="max-w-120"
                  :class="{ 'is-error': second_additional_driver.errors.idType }"
                  v-model="second_additional_driver.idType"
                  placeholder=""
                  :options="idTypeOptions"
                  type="id"
                />
                <CustomDetailsInput
                  v-model="second_additional_driver.idNumber"
                  :placeholder="
                    second_additional_driver.idType == 'id' ? 'SA ID' : 'Passport number'
                  "
                  :class="{ 'is-error': second_additional_driver.errors.idNumber }"
                  id="secondAdditionalDriverIdNumber"
                />
              </div>
              <div class="mt-16 flex-row gap-25">
                <CustomDetailsSelect
                  v-model="second_additional_driver.dayOfBirth"
                  :options="days"
                  placeholder="Day of birth"
                  :class="{ 'is-error': second_additional_driver.errors.dayOfBirth }"
                  class="max-w-180"
                />
                <CustomDetailsSelect
                  v-model="second_additional_driver.monthOfBirth"
                  :options="months"
                  placeholder="Month of birth"
                  :class="{ 'is-error': second_additional_driver.errors.monthOfBirth }"
                  class="max-w-180"
                />
                <CustomDetailsSelect
                  v-model="second_additional_driver.yearOfBirth"
                  :options="years"
                  placeholder="Year of birth"
                  :class="{ 'is-error': second_additional_driver.errors.yearOfBirth }"
                />
              </div>
              <!-- <div class="mt-16">
              <CustomDetailsDatepicker
                v-model="second_additional_driver.dateOfBirth"
                placeholder="Date of birth"
                class="mt-16"
                type="date"
                :class="{ 'is-error': second_additional_driver.errors.dateOfBirth }"
              />
            </div> -->
              <div class="mt-16">
                <CustomDetailsSelect
                  v-model="second_additional_driver.gender"
                  placeholder="Gender"
                  :options="[
                    { name: 'Male', code: 'male' },
                    { name: 'Female', code: 'female' },
                  ]"
                  type="country"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="block-divider"></div>
        <div class="block-navigation-wrapper">
          <div class="block-navigation">
            <div class="block-navigation-back" v-on:click="backPage()">
              <b-icon icon="chevron-left" type="is-brand"> </b-icon>
              <span>Back</span>
            </div>
          </div>
          <div class="block-navigation">
            <div
              class="block-navigation-button"
              :class="blockOneIsReady ? 'button-ready' : ''"
              v-on:click="validatePrimaryDriver()"
            >
              <span>Continue</span>
            </div>
          </div>
        </div>
      </form>
    </transition>

    <transition name="rotate-in">
      <form v-if="block == 2">
        <div class="block-contents">
          <h2 class="block-heading mt-24">Payment details</h2>

          <div class="redeem-points-block mt-24">
            <h1 class="redeem-heading">
              <span :class="showRedeemDetails ? 'is-color' : ''">
                Redeem your Investec Rewards points
              </span>
              <!-- <img
                v-if="!showRedeemDetails"
                @click="showRedeemDetails = !showRedeemDetails"
                src="@/assets/images/icons/Circle.png"
                alt="circle icon"
              />
              <img
                v-else
                @click="showRedeemDetails = !showRedeemDetails"
                src="@/assets/images/icons/Close.png"
                alt="circle icon"
              /> -->
            </h1>

            <div class="mt-24" v-if="showRedeemDetails">
              <div class="redeem-description">
                You may only redeem Rewards points if you are a primary account holder and
                are registered for the Investec Rewards Programme. (Youth Accounts do not
                have access to Investec Rewards.)
              </div>

              <div class="how-it-works mt-24" @click="howItWorksModal = true">
                (How it works?)
              </div>

              <div class="flex-col mt-24">
                <b-field>
                  <b-radio
                    v-model="cardDetails.redeemPercentage"
                    name="redeemPercentage"
                    :native-value="0"
                    >I do not wish to redeem</b-radio
                  >
                </b-field>
                <b-field>
                  <b-radio
                    v-model="cardDetails.redeemPercentage"
                    name="redeemPercentage"
                    native-value="50%"
                    >Redeem my Rewards points toward 50% of my booking amount</b-radio
                  >
                </b-field>
                <b-field>
                  <b-radio
                    v-model="cardDetails.redeemPercentage"
                    name="redeemPercentage"
                    native-value="100%"
                    >Redeem my Rewards points toward 100% of my booking amount</b-radio
                  >
                </b-field>
              </div>
            </div>

            <div class="redeem-divider mt-24"></div>
          </div>

          <div class="flex-row mt-24">
            <b-field>
              <b-checkbox
                v-model="payerSameAsDriver"
                name="payerSameAsDriver"
                @change="payerTitle.value.focus()"
                >Payer same as driver</b-checkbox
              >
            </b-field>
          </div>

          <h2 class="block-heading mt-24">Card details</h2>
          <div class="visa-logo">
            <img
              src="@/assets/images/logos/Visa_Brandmark_Blue_RGB_2021.png"
              alt="visa logo"
            />
            <span v-show="this.selectedCar.rateType !== 'Express Lane'">Pay instantly and securely with your Investec Visa card.</span>
            <span v-show="this.selectedCar.rateType === 'Express Lane'">Payment must be made with the primary driver's Investec Visa card.</span>
          </div>
          <div class="mt-24 flex-row gap-25">
            <CustomDetailsSelect
              ref="payerTitle"
              class="max-w-120"
              v-model="payer.title"
              placeholder="Title"
              :options="titleOptions"
              type="country"
              :class="{ 'is-error': payer.errors.title }"
              :update-key="payer.title"
              id="payerTitle"
            />
            <CustomDetailsInput
              v-model="payer.firstName"
              placeholder="First name as per ID/passport"
              :class="{ 'is-error': payer.errors.firstName }"
              id="payerFirstName"
            />
            <CustomDetailsInput
              v-model="payer.lastName"
              placeholder="Surname as per ID/passport"
              :class="{ 'is-error': payer.errors.lastName }"
              id="payerLastName"
            />
          </div>
          <CustomDetailsInput
            class="mt-16"
            v-model="cardDetails.cardNumber"
            placeholder="Card number"
            :class="{
              'is-error':
                cardDetails.errors.cardNumber || 
                cardDetails.errors.isValidCardNumber ||
                cardDetails.errors.isVirtualOnExpress
            }"
            id="cardNumber"
          />
          <label v-if="cardDetails.isVirtualOnExpress" class="error-label">
            Virtual cards not accepted for Express lane. Please use physical card in renter's name.
          </label>
          <div class="mt-16 flex-row gap-25">
            <CustomDetailsInput
              v-model="cardDetails.cvv"
              placeholder="CVV"
              :class="{ 'is-error': cardDetails.errors.cvv }"
            />
            <CustomDetailsSelect
              v-model="cardDetails.expiryMonth"
              :options="months"
              placeholder="Month"
              :class="{ 'is-error': cardDetails.errors.expiryMonth ||
                  cardDetails.errors.expiryDate
              }"
              id="cardExpiryMonth"
            />
            <CustomDetailsSelect
              v-model="cardDetails.expiryYear"
              :options="cardYears"
              placeholder="Year"
              :class="{
                'is-error':
                  cardDetails.errors.expiryYear || cardDetails.errors.expiryDate
              }"
              id="cardYear"
            />
          </div>
          <label v-if="cardDetails.errors.expiryDate" class="error-label">
            Your card is expired. Please use a valid card.
          </label>
          <!-- <CustomDetailsSelect v-model="payer.country" :options="countrycodes" placeholder="Nationality" type="country" /> -->
          <div class="mt-16 flex-row gap-25">
            <CustomDetailsSelect
              class="max-w-120"
              :class="{ 'is-error': payer.errors.idType }"
              v-model="payer.idType"
              placeholder=""
              :options="idTypeOptions"
              type="id"
            />
            <CustomDetailsInput
              v-model="payer.idNumber"
              :placeholder="payer.idType == 'id' ? 'SA ID' : 'Passport number'"
              :class="{ 'is-error': payer.errors.idNumber }"
              id="payerIdNumber"
            />
          </div>
          <CustomDetailsSelect
            v-model="payer.idIssuingCountry"
            :options="countrycodes"
            placeholder="Country of issue"
            class="mt-16"
            type="country"
            :update-key="payer.idIssuingCountry"
            :class="{ 'is-error': payer.errors.idIssuingCountry }"
            id="payerIdIssuingCountry"
          />
          <!-- <div class="mt-16 flex-row gap-25">
            <CustomDetailsSelect
              v-model="payer.dayOfBirth"
              :options="days"
              placeholder="Day of birth"
              :class="{ 'is-error': payer.errors.dayOfBirth }"
              class="max-w-180"
            />
            <CustomDetailsSelect
              v-model="payer.monthOfBirth"
              :options="months"
              placeholder="Month of birth"
              :class="{ 'is-error': payer.errors.monthOfBirth }"
              class="max-w-180"
            />
            <CustomDetailsSelect
              v-model="payer.yearOfBirth"
              :options="years"
              placeholder="Year of birth"
              :class="{ 'is-error': payer.errors.yearOfBirth }"
            />
          </div> -->
          <!-- <div class="mt-16">
            <CustomDetailsDatepicker
              v-model="payer.dateOfBirth"
              placeholder="Date of birth"
              class="mt-16"
              type="date"
              :update-key="payer.dateOfBirth"
              :class="{ 'is-error': payer.errors.dateOfBirth }"
            />
          </div> -->
          <CustomDetailsInput
            v-model="payer.email"
            placeholder="Email address"
            class="mt-16"
            type="email"
            :class="{ 'is-error': payer.errors.email }"
            id="payerEmail"
          />
          <CustomDetailsInput
            v-model="payer.mobileNumber"
            placeholder="Mobile number"
            class="mt-16"
            type="tel"
            :class="{ 'is-error': payer.errors.mobileNumber }"
            id="payerMobileNumber"
          />

          <div class="flex-row mt-24">
            <b-field>
              <b-radio
                v-model="termsAndConditions"
                name="termsAndConditions"
                :native-value="0"
                :class="{ 'is-error': payer.errors.termsAndConditions }"
                >I confirm that I have read and understand Investec Travel's
                <a
                  style="text-decoration: underline"
                  @click="
                    invsyLink('https://www.investectravel.com/terms-and-conditions/')
                  "
                  >terms and conditions</a
                >
                of my booking.</b-radio
              >
            </b-field>
          </div>

          <div class="flex-row mt-24">
            <b-field>
              <b-radio
                v-model="inclusionsAndExclusions"
                name="inclusionsAndExclusions"
                :native-value="0"
                :class="{ 'is-error': payer.errors.inclusionsAndExclusions }"
                >I confirm that I have read and understand the
                <a style="text-decoration: underline" @click="toggleInclusionsModal">
                  inclusions and exclusions</a
                >
                as well as the
                <a
                  style="text-decoration: underline"
                  @click="toggleRentalConditionsModal"
                >
                  rental conditions</a
                >
                of my booking.
              </b-radio>
            </b-field>
          </div>
        </div>
        <div class="block-divider"></div>
        <div class="block-navigation-wrapper">
          <div class="block-navigation">
            <div class="block-navigation-back" v-on:click="backFromPaymentDetails()">
              <b-icon icon="chevron-left" type="is-brand"> </b-icon>
              <span>Back</span>
            </div>
          </div>
          <div class="block-navigation">
            <div class="block-navigation-button" :class="(blockTwoIsReady && !bookingTimeError) ? 'button-ready' : ''" v-on:click="!bookingTimeError ? validatePaymentDetails() : null">
              <span>Continue</span>
            </div>
          </div>
        </div>
        
        <b-message type="is-danger" class="booking-time-error error-label" v-if="bookingTimeError">{{ bookingTimeError }}</b-message>

      </form>
    </transition>

    <transition name="rotate-in">
      <form class="block-4" v-if="block == 5">
        <b-message type="is-danger">
          <h1>Something went wrong during the reservation process!</h1>
          <div>
            <p>{{ verification_error }}</p>
          </div>
        </b-message>

        <div class="block-navigation-wrapper back-button">
          <div class="block-navigation">
            <div v-on:click="back()">
              <i class="fas fa-arrow-circle-left"></i>
              <span>Back</span>
            </div>
          </div>
        </div>
      </form>
      <!-- Failure Modal as Full-Screen Overlay -->
      <b-modal :active.sync="failureModal" custom-class="fullscreen-modal">
        <FailureCard @closeModal="closeFailureModal()"/>
      </b-modal>
    </transition>
  </div>
</template>

<script>
import Api from "../services/Api.service.js";
import { mapState } from "vuex";
import moment from "moment";
import ClipLoader from "vue-spinner/src/ClipLoader.vue";
import CountryCodes from "../services/CountryCodes.service.js";
import Logging from "../services/Logging.service";
import CustomDetailsSelect from "@/components/CustomDetailsSelect.vue";
import CustomDetailsInput from "@/components/CustomDetailsInput.vue";
import CustomDetailsDatepicker from "@/components/CustomDetailsDatepicker.vue";
import inclusionsModal from "@/components/inclusionsModal.vue";
import rentalConditionsModal from "@/components/rentalConditionsModal.vue";
import FailureCard from "@/components/FailureCard.vue";
import { FeesData } from "@/services/Fees.js";

export default {
  data() {
    const today = new Date();

    return {
      block: 1,
      dob: {
        min: new Date(today.getFullYear() - 100, today.getMonth(), today.getDate()),
        max: new Date(today.getFullYear() - 18, today.getMonth(), today.getDate()),
      },
      days: [...Array(31).keys()].map((e) => e + 1),
      months: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      // possible driver years of birth
      years: [...Array(new Date().getFullYear() - 1929 - 18).keys()].map((e) => e + 1930),
      cardYears: [...Array(10).keys()].map((e) => e + new Date().getFullYear()),
      payerSameAsDriver: false,
      errors: [],
      bookingTimeError: undefined,
      isAdditionalDriver: null,
      isNotAdditionalDriver: false,
      termsAndConditions: null,
      inclusionsAndExclusions: null,
      howItWorksModal: false,
      showRedeemDetails: true,
      driver: {
        title: "Mr",
        firstName: null,
        lastName: null,
        initials: null,
        gender: "o",
        dateOfBirth: null,
        dayOfBirth: null,
        monthOfBirth: null,
        yearOfBirth: null,
        nationality: null,
        idType: "id",
        idNumber: null,
        idExpiryDate: null,
        idIssuingCountry: null,
        email: null,
        mobileNumber: null,
        errors: [],
      },
      payer: {
        title: "Mr",
        email: null,
        firstName: null,
        initials: null,
        lastName: null,
        mobileNumber: null,
        idType: "id",
        idNumber: null,
        idIssuingCountry: "ZAF",
        idExpiryDate: null,
        errors: [],
      },
      first_additional_driver: {
        selected: false,
        title: "Mr",
        gender: "male",
        firstName: null,
        lastName: null,
        errors: [],
        dateOfBirth: null,
        dayOfBirth: null,
        monthOfBirth: null,
        yearOfBirth: null,
        idType: "id",
        idNumber: null,
      },
      second_additional_driver: {
        selected: this.isSecondAdditionalDriver,
        title: "Mr",
        gender: "male",
        firstName: null,
        lastName: null,
        errors: [],
        dateOfBirth: null,
        dayOfBirth: null,
        monthOfBirth: null,
        yearOfBirth: null,
        idType: "id",
        idNumber: null,
      },
      cardDetails: {
        cardType: "VI",
        cardNumber: null,
        expiryMonth: null,
        expiryYear: null,
        cardHolderName: null,
        cvv: null,
        redeemPercentage: 0,
        errors: [],
      },
      labelPosition: null,
      loader: {
        isLoading: false,
        stepCount: 2500,
        backgroundColor: "linear-gradient(to right, lightgray, gray)",
        opacity: 0.5,
        spinnerSize: "22px",
        spinnerColor: "#0fa5a4",
        currentStep: "Connecting to our partners.",
        progressSteps: ["Reserving flights.", "Preparing checkout."],
      },
      verification_error: "",
      // titleOptions: ["Mr", "Mrs", "Miss", "Dr", "Prof", "Adv"],
      titleOptions: [
        { name: "Mr", code: "Mr" },
        { name: "Mrs", code: "Mrs" },
        { name: "Miss", code: "Miss" },
        { name: "Ms", code: "Ms" },
      ],
      idTypeOptions: [
        { name: "ID", code: "id" },
        { name: "Passport", code: "p" },
      ],
      isPriceExpanded: true,
      inclusionsModal: { value: null, key: null },
      rentalConditionsModal: { value: null, key: null },
      currentIndex: 1,
      failureModal: false,
    };
  },
  watch: {
    payerSameAsDriver: {
      handler(newVal) {
        return this.setPayerToDriver(newVal);
      },
      deep: true,
    },
    cardDetails: {
      handler(newVal) {
        if (newVal.cardNumber) {
          let v = newVal.cardNumber.replace(/\s+/g, "").replace(/[^0-9]/gi, "");
          let matches = v.match(/\d{4,16}/g);
          let match = (matches && matches[0]) || "";
          let parts = [];
          for (let i = 0; i < match.length; i += 4) {
            parts.push(match.substring(i, i + 4));
          }
          if (parts.length) {
            this.cardDetails.cardNumber = parts.join(" ");
          } else {
            this.cardDetails.cardNumber = newVal.cardNumber;
          }
        }
      },
      deep: true,
    },

    driverId: {
      handler(value) {
        this.setDateOfBirthFromSouthAfricanId(this.driver, value);
      },
    },

    firstAdditionalDriverId: {
      handler(value) {
        this.setDateOfBirthFromSouthAfricanId(this.first_additional_driver, value);
      },
    },

    secondAdditionalDriverId: {
      handler(value) {
        this.setDateOfBirthFromSouthAfricanId(this.second_additional_driver, value);
      },
    },
  },
  methods: {
    saveDataToStore() {
      return new Promise((resolve, reject) => {
        this.$store.commit("setLastDriverDetails", this.driver);
        this.$store.commit("setLastPayerDetails", this.payer);
        this.$store.commit("setLastCardDetails", this.cardDetails);
        this.$store.commit("setLastFirstAdditionalDriver", this.first_additional_driver);
        this.$store.commit("setLastSecondAdditionalDriver", this.second_additional_driver);
        resolve(true);
      });
    },
    invsyLink(url) {
      this.$store.dispatch("invsyLink", url);
    },
    closeFailureModal() {
      this.failureModal = false;
      this.loader.isLoading = false;
      this.block = 2;
    },
    reserve() {
      this.loader.isLoading = true;
      this.$store.commit("setPayerDetails", this.payer);
      this.$store.commit("setDriverDetails", this.driver);
      this.requestCar();
    },
    onAdditionalDriver() {
      this.isNotAdditionalDriver = !this.isAdditionalDriver;
      this.first_additional_driver.selected = true;
    },
    onNotAdditionalDriver() {
      this.isAdditionalDriver = !this.isNotAdditionalDriver;
      this.first_additional_driver.selected = false;
    },
    backFromPaymentDetails() {
      if (this.bookingTimeError) {
        this.bookingTimeError = null;
        this.$router.push('/');
      } else {
        this.bookingTimeError = null;
        this.block = 1;
      }
    },
    formatCardExpiry() {
      if (this.cardDetails.expiryMonth && this.cardDetails.expiryYear) {
        // as MM/YY format pad the month with a leading zero if needed
        const month = String(this.cardDetails.expiryMonth).padStart(2, "0");
        // get the last 2 digits of the year
        const year = String(this.cardDetails.expiryYear).slice(-2);
        // return the concatenated string
        return `${month}/${year}`;
      }
      return "";
    },
    async requestCar() {
      try {
        const reserveResult = await Api.request({
          cover_type: this.selectedCar.rateType,
          driver_title: this.driver.title,
          driver_initials: this.driver.initials,
          driver_firstname: this.driver.firstName,
          driver_lastname: this.driver.lastName,
          driver_mobile: this.driver.mobileNumber,
          driver_email: this.driver.email,
          driver_id_type: this.driver.idType,
          driver_id_expiry: this.formatCardExpiry(),
          driver_id_issuing_country: this.driver.idIssuingCountry,
          driver_id_number: this.driver.idNumber,
          renter_title: this.payer.title,
          renter_initials: this.payer.initials,
          renter_firstname: this.payer.firstName,
          renter_lastname: this.payer.lastName,
          renter_mobile: this.payer.mobileNumber,
          renter_tel_no: this.payer.mobileNumber,
          renter_email: this.payer.email,
          renter_id_type: this.payer.idType,
          //renter_id_expiry: this.payer.idExpiryDate,
          renter_id_issuing_country: this.payer.idIssuingCountry,
          renter_id_number: this.payer.idNumber,
          card_holder: this.cardDetails.cardHolderName,
          card_number: this.cardDetails.cardNumber.replace(/\s/g, ""),
          card_expiry_date: this.formatCardExpiry(),
          amount: this.totalPrice,
          ccv: this.cardDetails.cvv,
          selectedCar: this.selectedCar,
          extras: this.selectedCar.totalExtras.toString(),
          extrasPrice: this.selectedCar.totalExtrasPrice,
          days: this.selectedCar.totalDays,
          searchParameters: this.searchParameters,
          pickup: this.searchParameters.pickupLocation.locationName,
          dropoff: this.searchParameters.dropoffLocation.locationName,
          pickupTime: this.searchParameters.pickupTime.format("DD/MM/YYYY HH:mm"),
          dropoffTime: this.searchParameters.dropoffTime.format("DD/MM/YYYY HH:mm"),
          group: this.selectedCar.group,
          carName: this.selectedCar.name,
          redeemPercentage: this.cardDetails.redeemPercentage,
          additionalDriverInformation: [
            this.isAdditionalDriver ? this.first_additional_driver : null,
            this.isSecondAdditionalDriver ? this.second_additional_driver : null,
          ],
          flightDetails: this.flightDetails ? this.flightDetails : "No"
        });
        if (reserveResult.data.status || reserveResult.data.ReplyCCGroup) {
          // to test the failure modal
          // console.log("request successful");
          // this.failureModal = true;
          // return true;
          // end test
          this.$store.commit("setReserveResponse", reserveResult.data);
          this.$router.push("confirmation");
        } else {
          if (
            reserveResult.data.hasOwnProperty("verification") &&
            !reserveResult.data.verification
          ) {
            this.loader.isLoading = false;
            
            if (!reserveResult.data.status) {
              this.bookingTimeError = reserveResult.data.message;
            } else {
              this.verification_error = reserveResult.data.message;
              this.block++;
            }
          } else {
            console.log("RESERVE RESULT", reserveResult);
            console.log("request failed at server");
            this.$store.commit("setReserveResponse", reserveResult.data);
            this.failureModal = true;
          }
        }
      } catch (error) {
        console.log("failed to make reserve request to the travel api.");
        console.log(error);
        this.loader.isLoading = false;
        this.failureModal = true;
      }
    },
    formatDates(driver) {
      driver.dateOfBirth = moment(driver.dateOfBirth).format("DD/MM/YYYY");
      driver.idExpiryDate = moment(driver.idExpiryDate).format("DD/MM/YYYY");
      return driver;
    },
    formattedPrice(n) {
      // also to 2 decimal places
      n = n.toFixed(2);
      var parts = n.toString().split(".");
      const numberPart = parts[0];
      const decimalPart = parts[1];
      const thousands = /\B(?=(\d{3})+(?!\d))/g;
      // Replace positions matched by the regular expression with a comma instead of space
      return numberPart.replace(thousands, ",") + (decimalPart ? "." + decimalPart : "");
    },
    isEmpty(obj) {
      for (let key in obj) {
        if (obj.hasOwnProperty(key)) return false;
      }
      return true;
    },
    determineTotal() {
      return `Total booking cost R${this.totalPrice}`;
    },
    stepCurrentProgress: function () {
      const it = this.loader.progressSteps[Symbol.iterator]();
      const int = setInterval(() => {
        const next = it.next();
        if (!next.done) {
          this.loader.currentStep = next.value;
        } else {
          clearInterval(int);
        }
      }, this.loader.stepCount);
    },
    setPayerToDriver: function (isTrue) {
      if (isTrue) {
        this.payer.title = this.driver.title;
        this.payer.email = this.driver.email;
        this.payer.firstName = this.driver.firstName;
        this.payer.lastName = this.driver.lastName;
        this.payer.mobileNumber = this.driver.mobileNumber;
        this.payer.initials = this.driver.initials;
        this.payer.idType = this.driver.idType;
        this.payer.idNumber = this.driver.idNumber;
        this.payer.idIssuingCountry = this.driver.idIssuingCountry;
        // this.payer.dateOfBirth = this.driver.dateOfBirth;
      } else {
        this.payer.initials = null;
        this.payer.title = null;
        this.payer.email = null;
        this.payer.firstName = null;
        this.payer.lastName = null;
        this.payer.mobileNumber = null;
        this.payer.idType = "id";
        this.payer.idNumber = null;
        this.payer.idIssuingCountry = "ZAF";
      }
    },
    validatePrimaryDriver: function () {
      // this.block++;
      // return true;
      this.errors = [];
      let valid = true;
      this.driver.errors = [];
      // validate day month and year of birth
      if (!this.driver.dayOfBirth) {
        this.driver.errors.dayOfBirth = true;
        valid = false;
      }
      if (!this.driver.monthOfBirth) {
        this.driver.errors.monthOfBirth = true;
        valid = false;
      }
      if (!this.driver.yearOfBirth) {
        this.driver.errors.yearOfBirth = true;
        valid = false;
      }

      this.driver.dateOfBirth = moment(
        `${this.driver.yearOfBirth}-${this.driver.monthOfBirth}-${this.driver.dayOfBirth}`,
        "YYYY-MM-DD"
      ).format("YYYY-MM-DD");

      if (!this.driver.firstName) {
        this.driver.errors.firstName = true;
        this.scrollToError("driverFirstName");
        valid = false;
      } else if (!this.validName(this.driver.firstName)) {
        this.driver.errors.firstName = true;
        valid = false;
      }
      if (!this.driver.lastName) {
        this.driver.errors.lastName = true;
        this.scrollToError("driverLastName");
        valid = false;
      } else if (!this.validName(this.driver.lastName)) {
        this.driver.errors.lastName = true;
        valid = false;
      }
      if (!this.driver.initials) {
        this.driver.errors.initials = true;
        this.scrollToError("driverInitials");
        valid = false;
      }
      if (!this.driver.nationality) {
        this.driver.errors.nationality = true;
        this.scrollToError("driverNationality");
        valid = false;
      }
      if (!this.driver.idNumber) {
        this.driver.errors.idNumber = true;
        this.scrollToError("driverIdNumber");
        valid = false;
      } else if (this.driver.idType == "id" && !this.validID(this.driver.idNumber)) {
        this.driver.errors.idNumber = true;
        valid = false;
      }
      if (!this.driver.idIssuingCountry) {
        this.driver.errors.idIssuingCountry = true;
        this.scrollToError("driverIdIssuingCountry");
        valid = false;
      }
      if (!this.driver.gender) {
        this.driver.errors.gender = true;
        valid = false;
      }
      if (!this.driver.idType) {
        this.driver.errors.idType = true;
        valid = false;
      }
      if (!this.driver.title) {
        this.driver.errors.title = true;
        valid = false;
      }
      // if (this.driver.idType === "p" && !this.driver.idExpiryDate) {
      //   this.driver.errors.idExpiryDate = true;
      //   valid = false;
      // }
      if (!this.driver.dateOfBirth) {
        this.driver.errors.dateOfBirth = true;
        valid = false;
      }
      if (!this.driver.mobileNumber) {
        this.driver.errors.mobileNumber = true;
        this.scrollToError("driverMobileNumber");
        valid = false;
      }
      if (!this.validMobile(this.driver.mobileNumber)) {
        this.driver.errors.isValidMobileNumber = true;
        this.driver.errors.mobileNumber = true;
        valid = false;
      }
      if (!this.driver.email) {
        this.driver.errors.email = true;
        this.scrollToError("driverEmailAddress");
        valid = false;
      }
      if (!this.validEmail(this.driver.email)) {
        this.driver.errors.email = true;
        this.driver.errors.isValidEmail = true;
        valid = false;
      }
      if (this.isAdditionalDriver === null) {
        this.driver.errors.isAdditionalDriver = true;
        valid = false;
      }
      if (!valid) {
        this.errors.push("One or more fields are incomplete");
        //Logging.logUserData("0", "DRIVER-VALIDATION", this.$data);
        return false;
      }
      let additionalDriverCheck = this.validateAdditionalDrivers();
      if (additionalDriverCheck) {
        this.errors = [];
        this.block = 2;
      } else {
        return false;
      }
      // Scroll to the top of the page so the "Reward Points" section
      // is in the viewport
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    validatePaymentDetails: function () {
      this.errors = [];
      let valid = true;
      this.payer.errors = [];
      this.cardDetails.errors = [];
      if (!this.payer.firstName) {
        this.payer.errors.firstName = true;
        this.scrollToError("payerFirstName");
        valid = false;
      } else if (!this.validName(this.payer.firstName)) {
        this.payer.errors.firstName = true;
        this.scrollToError("payerFirstName");
        valid = false;
      }

      // handle unprocessed fields
      this.payer.initials =
        this.payer.firstName.charAt(0) + this.payer.lastName.charAt(0);
      this.cardDetails.cardHolderName = this.payer.firstName + " " + this.payer.lastName;

      if (!this.payer.lastName) {
        this.payer.errors.lastName = true;
        this.scrollToError("payerLastName");
        valid = false;
      } else if (!this.validName(this.payer.lastName)) {
        this.payer.errors.lastName = true;
        valid = false;
      }
      if (!this.payer.title) {
        this.payer.errors.title = true;
        this.scrollToError("payerTitle");
        valid = false;
      }
      if (!this.payer.initials) {
        this.payer.errors.initials = true;
        valid = false;
      }
      if (!this.payer.idNumber) {
        this.payer.errors.idNumber = true;
        valid = false;
      }
      if (!this.payer.mobileNumber) {
        this.payer.errors.mobileNumber = true;
        valid = false;
      }
      if (!this.validMobile(this.payer.mobileNumber)) {
        this.payer.errors.isValidMobileNumber = true;
        this.payer.errors.mobileNumber = true;
        valid = false;
      }
      if (!this.payer.email) {
        this.payer.errors.email = true;
        valid = false;
      } else if (!this.validEmail(this.payer.email)) {
        this.payer.errors.isValidEmail = true;
        this.payer.errors.email = true;
        valid = false;
      }
      if (this.termsAndConditions === null) {
        this.payer.errors.termsAndConditions = true;
        valid = false;
      }
      if (this.inclusionsAndExclusions === null) {
        this.payer.errors.inclusionsAndExclusions = true;
        valid = false;
      }
      if (!this.cardDetails.cardHolderName) {
        this.cardDetails.errors.cardHolderName = true;
        valid = false;
        console.log("Cardholder name fails");
      }
      if (this.cardDetails.isVirtualOnExpress){
        this.cardDetails.errors.isVirtualOnExpress = true;
        valid = false;
      }

      if (!this.cardDetails.cardNumber) {
        this.cardDetails.errors.cardNumber = true;
        valid = false;
      } else if (!this.validCreditCard(this.cardDetails.cardNumber.replace(/\s/g, ""))) {
        this.cardDetails.errors.isValidCardNumber = true;
        valid = false;
      }
      if (
        this.cardDetails.cardNumber &&
        this.cardDetails.cardNumber.replace(/\s/g, "").length !== 16
      ) {
        this.cardDetails.errors.isValidCardNumber = true;
        valid = false;
      }
      if (!this.cardDetails.expiryMonth) {
        this.cardDetails.errors.expiryMonth = true;
        valid = false;
      }
      if (!this.cardDetails.expiryYear) {
        this.cardDetails.errors.expiryYear = true;
        valid = false;
      }
      if (this.cardDetails.expiryMonth && this.cardDetails.expiryYear) {
        let expiryDate = new Date(
          this.cardDetails.expiryYear,
          this.cardDetails.expiryMonth,
          0
        );
        let today = new Date();
        if (expiryDate < today) {
          this.errors.push("Card has expired.");
          this.cardDetails.errors.expiryDate = true;
          this.scrollToError("cardExpiryMonth");
          valid = false;
        }
      }
      if (!this.cardDetails.cvv) {
        this.cardDetails.errors.cvv = true;
        valid = false;
      }
      if (!valid) {
        this.errors.push("One or more fields are incomplete");
        console.log(this.cardDetails.errors);
        // Logging.logUserData("0", "PAYMENT-DETAILS-VALIDATION", this.$data);
        return false;
      }
      this.errors = [];

      if (this.$store.state.isApiDown) {
        return false;
      }

      this.reserve();
    },

    validateAdditionalDrivers: function () {
      this.errors = [];
      let valid = true;

      this.first_additional_driver.errors = [];
      this.second_additional_driver.errors = [];

      if (this.isAdditionalDriver) {
        // check date of birth is valid
        if (!this.first_additional_driver.dayOfBirth) {
          this.first_additional_driver.errors.dayOfBirth = true;
          this.scrollToError("firstAdditionalDriverDayOfBirth");
          valid = false;
        }
        if (!this.first_additional_driver.monthOfBirth) {
          this.first_additional_driver.errors.monthOfBirth = true;
          this.scrollToError("firstAdditionalDriverMonthOfBirth");
          valid = false;
        }
        if (!this.first_additional_driver.yearOfBirth) {
          this.first_additional_driver.errors.yearOfBirth = true;
          this.scrollToError("firstAdditionalDriverYearOfBirth");
          valid = false;
        }

        if (!valid) {
          this.errors.push("One or more fields are incomplete");
          // Logging.logUserData("0", "ADDITIONAL-DRIVER-VALIDATION", this.$data);
          return false;
        }

        // create date of birth
        this.first_additional_driver.dateOfBirth = moment(
          `${this.first_additional_driver.yearOfBirth}-${this.first_additional_driver.monthOfBirth}-${this.first_additional_driver.dayOfBirth}`,
          "YYYY-MM-DD"
        ).format("YYYY-MM-DD");

        if (!this.first_additional_driver.firstName) {
          this.first_additional_driver.errors.firstName = true;
          this.scrollToError("firstAdditionalDriverFirstName");
          valid = false;
        } else if (!this.validName(this.first_additional_driver.firstName)) {
          this.first_additional_driver.errors.firstName = true;
          valid = false;
        }

        if (!this.first_additional_driver.lastName) {
          this.first_additional_driver.errors.lastName = true;
          this.scrollToError("firstAdditionalDriverLastName");
          valid = false;
        } else if (!this.validName(this.first_additional_driver.lastName)) {
          this.first_additional_driver.errors.lastName = true;
          valid = false;
        }

        if (!this.first_additional_driver.dateOfBirth) {
          this.first_additional_driver.errors.dateOfBirth = true;
          valid = false;
        }

        if (!this.first_additional_driver.idNumber) {
          this.first_additional_driver.errors.idNumber = true;
          this.scrollToError("firstAdditionalDriverIdNumber");
          valid = false;
        } else if (
          this.first_additional_driver.idType == "id" &&
          !this.validID(this.first_additional_driver.idNumber)
        ) {
          this.firstAdditionalDriver.errors.idNumber = true;
          valid = false;
        }

        if (!this.first_additional_driver.gender) {
          this.first_additional_driver.errors.gender = true;
          valid = false;
        }
        if (!this.first_additional_driver.idType) {
          this.first_additional_driver.errors.idType = true;
          valid = false;
        }
      }

      if (this.isSecondAdditionalDriver) {
        // check date of birth is valid
        if (!this.second_additional_driver.dayOfBirth) {
          this.second_additional_driver.errors.dayOfBirth = true;
          this.scrollToError("secondAdditionalDriverDayOfBirth");
          valid = false;
        }
        if (!this.second_additional_driver.monthOfBirth) {
          this.second_additional_driver.errors.monthOfBirth = true;
          this.scrollToError("secondAdditionalDriverMonthOfBirth");
          valid = false;
        }
        if (!this.second_additional_driver.yearOfBirth) {
          this.second_additional_driver.errors.yearOfBirth = true;
          this.scrollToError("secondAdditionalDriverYearOfBirth");
          valid = false;
        }

        if (!valid) {
          this.errors.push("One or more fields are incomplete");
          // Logging.logUserData("0", "ADDITIONAL-DRIVER-VALIDATION", this.$data);
          return false;
        }

        // make dateOfBirth from dob object
        this.second_additional_driver.dateOfBirth = moment(
          `${this.second_additional_driver.yearOfBirth}-${this.second_additional_driver.monthOfBirth}-${this.second_additional_driver.dayOfBirth}`,
          "YYYY-MM-DD"
        ).format("YYYY-MM-DD");

        if (!this.second_additional_driver.firstName) {
          this.second_additional_driver.errors.firstName = true;
          this.scrollToError("secondAdditionalDriverFirstName");
          valid = false;
        } else if (!this.validName(this.second_additional_driver.firstName)) {
          this.second_additional_driver.errors.firstName = true;
          valid = false;
        }

        if (!this.second_additional_driver.lastName) {
          this.second_additional_driver.errors.lastName = true;
          valid = false;
        } else if (!this.validName(this.second_additional_driver.lastName)) {
          this.second_additional_driver.errors.lastName = true;
          this.scrollToError("secondAdditionalDriverLastName");
          valid = false;
        }

        if (!this.second_additional_driver.dateOfBirth) {
          this.second_additional_driver.errors.dateOfBirth = true;
          valid = false;
        }

        if (!this.second_additional_driver.idNumber) {
          this.second_additional_driver.errors.idNumber = true;
          this.scrollToError("secondAdditionalDriverIdNumber");
          valid = false;
        } else if (
          this.second_additional_driver.idType == "id" &&
          !this.validID(this.second_additional_driver.idNumber)
        ) {
          this.second_additional_driver.errors.idNumber = true;
          valid = false;
        }

        if (!this.second_additional_driver.gender) {
          this.second_additional_driver.errors.gender = true;
          valid = false;
        }
        if (!this.second_additional_driver.idType) {
          this.second_additional_driver.errors.idType = true;
          valid = false;
        }
      }

      if (!valid) {
        this.errors.push("One or more fields are incomplete");
        // Logging.logUserData("0", "ADDITIONAL-DRIVER-VALIDATION", this.$data);
        return false;
      }
      this.errors = [];
      return true;
    },
    // validatePaymentDetails: function () {
    //   this.errors = [];
    //   let valid = true;
    //   this.cardDetails.errors = [];
    //   if (!this.cardDetails.cardHolderName) {
    //     this.cardDetails.errors.cardHolderName = true;
    //     valid = false;
    //   }
    //   if (!this.cardDetails.cardNumber) {
    //     this.cardDetails.errors.cardNumber = true;
    //     valid = false;
    //   } else if (!this.validCreditCard(this.cardDetails.cardNumber.replace(/\s/g, ""))) {
    //     this.cardDetails.errors.isValidCardNumber = true;
    //     valid = false;
    //   }
    //   if (
    //     this.cardDetails.cardNumber &&
    //     this.cardDetails.cardNumber.replace(/\s/g, "").length !== 16
    //   ) {
    //     this.cardDetails.errors.isValidCardNumber = true;
    //     valid = false;
    //   }
    //   if (!this.cardDetails.expiryMonth) {
    //     this.cardDetails.errors.expiryMonth = true;
    //     valid = false;
    //   }
    //   if (!this.cardDetails.expiryYear) {
    //     this.cardDetails.errors.expiryYear = true;
    //     valid = false;
    //   }
    //   if (!this.cardDetails.cvv) {
    //     this.cardDetails.errors.cvv = true;
    //     valid = false;
    //   }
    //   if (!valid) {
    //     this.errors.push("One or more fields are incomplete");
    //     Logging.logUserData("0", "CARD-DETAILS-VALIDATION", this.$data);
    //     return false;
    //   }
    //   this.errors = [];
    //   this.reserve();
    // },
    // Scroll to the location of the first encountered validation error
    scrollToError(id) {
      this.$nextTick(() => {
        document
          .getElementById(id)
          .scrollIntoView({ behavior: "smooth", block: "start" });
      });
    },

    setDateOfBirthFromSouthAfricanId(driver, value) {
      let id = value;

      const isSouthAfricanId = driver.idType == "id";
      if (!isSouthAfricanId) return;

      const isValidIdFormat = /^\d+$/.test(id);
      if (!isValidIdFormat) return;

      const isValidIdLength = id.length >= 6;
      if (!isValidIdLength) {
        driver.dateOfBirth = null;
        return;
      }

      const currentYear = new Date().getFullYear().toString().substring(2, 4);
      let yearStart = id.substring(0, 2) <= currentYear ? "20" : "19";

      const dob = `${yearStart}${id.substring(0, 2)}-${id.substring(2, 4)}-${id.substring(
        4,
        6
      )}`;

      let newDate = new Date(dob);
      let day = newDate.getDate(); // day of the month (from 1 to 31)
      let month = newDate.getMonth() + 1; // month (from 1 to 12, note getMonth() returns from 0 to 11, hence the '+1')
      let year = newDate.getFullYear(); // four digit year

      this.$set(driver, "dateOfBirth", newDate);
      this.$set(driver, "dayOfBirth", day);
      this.$set(driver, "monthOfBirth", month);
      this.$set(driver, "yearOfBirth", year);
    },

    back: function () {
      this.errors = [];
      this.block--;
    },
    backPage: function () {
      this.errors = [];
      this.$router.go(-1);
    },
    validID: function (id) {
      return id.length == 13;
    },
    validEmail: function (email) {
      let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    validCreditCard: function (cardNumber) {
      let sliced = cardNumber.slice(0, 6);
      let premium = cardNumber.slice(0, 4);

      const cardFirstEightNumbers = cardNumber.slice(0, 8);

      const virtualCards = [
        '40216721',
        '40216722',
        '41735921',
        '41735922',
        '42225421',
        '42225422',
        '42651621',
        '42651622',
        '40603921',
        '40603922'
      ];

      if (
        sliced === "406942" ||
        sliced === "402167" ||
        sliced === "417359" ||
        sliced === "422254" ||
        sliced === "426516" ||
        premium === "4060" ||
        premium === "3921" ||
        premium === "4069" ||
        premium === "4021" ||
        premium === "6762"
      ) {
        if (
          this.selectedCar.rateType === "Express Lane" && virtualCards.includes(cardFirstEightNumbers)) {
          this.cardDetails.isVirtualOnExpress = true; //do not allow virtual cards for express lane
          this.scrollToError("cardNumber"); //added this scroll to error here for more responsiveness
          return false;
        } else {
          this.cardDetails.isVirtualOnExpress = false;
          let re = /^((4\d{3})|(5[1-5]\d{2})|(6011))-?\d{4}-?\d{4}-?\d{4}|3[4,7]\d{13}$/;
          return re.test(cardNumber);
        }
      }
      return false;
    },
    validName: function (string) {
      let re = /^[A-Za-z\s]+$/;
      return re.test(string);
    },
    validMobile: function (mobileNumber) {
      let re = /^(\+\d{1,3}[- ]?)?\d{10}$/;
      return re.test(mobileNumber);
    },
    validYear: function (year) {
      let re = /^(19|20)\d{2}$/;
      return re.test(year);
    },
    validMonth: function (month) {
      let re = /^(0[1-9]|1[012])$/;
      return re.test(month);
    },
    dobFromId(id) {
      const currentYear = new Date().getFullYear().toString().substring(2, 4);
      let yearStart = id.substring(0, 2) <= currentYear ? "20" : "19";

      const dob = `${yearStart}${id.substring(0, 2)}-${id.substring(2, 4)}-${id.substring(
        4,
        6
      )}`;

      let newDate = new Date(dob);
      let day = newDate.getDate(); // day of the month (from 1 to 31)
      let month = newDate.getMonth() + 1; // month (from 1 to 12, note getMonth() returns from 0 to 11, hence the '+1')
      let year = newDate.getFullYear(); // four digit year

      return {
        day: day,
        month: month,
        year: year,
      };
    },
    getExcessAmount(carGroup, coverType) {
      const rateMap = {
        Standard: 0,
        Super: 1,
        "Express Lane": 2,
      };

      const currentCoverType = rateMap[coverType] || coverType;

      if (currentCoverType == 0) {
        if (carGroup == "I") {
          return "6 600";
        } else if (carGroup == "Q") {
          return "7 500";
        } else if (carGroup == "N1") {
          return "17 500";
        } else if (carGroup == "O") {
          return "15 000";
        } else {
          return "6 000";
        }
      } else {
        if (carGroup == "I") {
          return "6 600";
        } else if (carGroup == "Q") {
          return "7 500";
        } else if (carGroup == "N1") {
          return "17 500";
        } else if (carGroup == "O") {
          return "15 000";
        } else {
          return "4 500";
        }
      }
    },
    toggleInclusionsModal() {
      if (this.inclusionsModal.key === this.currentIndex && this.inclusionsModal.value) {
        this.inclusionsModal = { key: null, value: false };
      } else {
        this.inclusionsModal = { key: this.currentIndex, value: true };
      }
    },
    toggleRentalConditionsModal() {
      if (
        this.rentalConditionsModal.key === this.currentIndex &&
        this.rentalConditionsModal.value
      ) {
        this.rentalConditionsModal = { key: null, value: false };
      } else {
        this.rentalConditionsModal = { key: this.currentIndex, value: true };
      }
    },
    backToSearch() {
      // Navigate back to search page (search parameters are already persisted)
      this.$router.push('/');
    },
  },
  mounted() {
    if (this.selectedCar.totalExtras.includes("additionalDriver")) {
      this.isAdditionalDriver = true;
    }
    if (this.isIframe) {
      this.driver.title = this.invsyUser.Title.Value;
      this.driver.initials = this.invsyUser.Initials;
      this.driver.firstName = this.invsyUser.FirstName;
      this.driver.lastName = this.invsyUser.LastName;
      this.driver.email = this.invsyUser.EmailAddress;
      this.driver.mobileNumber = this.invsyUser.MobileNumber;
      this.driver.idNumber = this.invsyUser.IdNumber;
      let invsyDob = this.isIframe ? this.dobFromId(this.invsyUser.IdNumber) : undefined;
      this.driver.dateOfBirth = new Date(invsyDob.year, invsyDob.month - 1, invsyDob.day);
      this.driver.dayOfBirth = invsyDob.day;
      this.driver.monthOfBirth = invsyDob.month;
      this.driver.yearOfBirth = invsyDob.year;
    }
    if (this.lastDriverDetails) {
      this.driver = this.lastDriverDetails;
    }
    if (this.lastPayerDetails) {
      this.payer = this.lastPayerDetails;
    }
    if (this.lastCardDetails) {
      this.cardDetails = this.lastCardDetails;
    }
    if (this.lastFirstAdditionalDriver) {
      this.first_additional_driver = this.lastFirstAdditionalDriver;
    }
    if (this.lastSecondAdditionalDriver) {
      this.second_additional_driver = this.lastSecondAdditionalDriver;
    }
  },
  computed: {
    ...mapState(["selectedCar", "searchParameters", "isIframe", "invsyUser", "lastDriverDetails", "lastPayerDetails", "lastCardDetails", "lastFirstAdditionalDriver", "lastSecondAdditionalDriver", "flightDetails"]),
    blockOneIsReady() {
      let driverReady = false;
      if (
        this.driver.initials &&
        this.driver.firstName &&
        this.driver.lastName &&
        this.driver.nationality &&
        this.driver.dayOfBirth &&
        this.driver.monthOfBirth &&
        this.driver.yearOfBirth &&
        this.driver.email &&
        this.driver.mobileNumber &&
        this.driver.idNumber &&
        this.isAdditionalDriver || this.isNotAdditionalDriver
      ) {
        driverReady = true;
      }
      let firstAdditionalDriverReady = true;
      if (this.isAdditionalDriver) {
        if (
          !this.first_additional_driver.firstName ||
          !this.first_additional_driver.lastName ||
          !this.first_additional_driver.idNumber ||
          !this.first_additional_driver.dayOfBirth ||
          !this.first_additional_driver.monthOfBirth ||
          !this.first_additional_driver.yearOfBirth
        ) {
          firstAdditionalDriverReady = false;
        }
      }
      let secondAdditionalDriverReady = true;
      if (this.isSecondAdditionalDriver) {
        if (
          !this.second_additional_driver.firstName ||
          !this.second_additional_driver.lastName ||
          !this.second_additional_driver.idNumber ||
          !this.second_additional_driver.dayOfBirth ||
          !this.second_additional_driver.monthOfBirth ||
          !this.second_additional_driver.yearOfBirth
        ) {
          secondAdditionalDriverReady = false;
        }
      }
      if (driverReady && firstAdditionalDriverReady && secondAdditionalDriverReady) {
        return true;
      } else {
        return false;
      }
    },
    blockTwoIsReady() {
      let payerReady = false;
      if (
        this.payer.firstName &&
        this.payer.lastName &&
        this.payer.email &&
        this.payer.mobileNumber &&
        this.payer.idNumber &&
        this.cardDetails.cardNumber &&
        this.cardDetails.expiryMonth &&
        this.cardDetails.expiryYear &&
        this.cardDetails.cvv &&
        this.termsAndConditions == 0 &&
        this.inclusionsAndExclusions == 0
      ) {
        payerReady = true;
      }
      // log everything 
      console.log("payerReady", payerReady);
      console.log("this.payer", this.payer);
      console.log("this.cardDetails", this.cardDetails);
      console.log("this.termsAndConditions", this.termsAndConditions);
      console.log("this.inclusionsAndExclusions", this.inclusionsAndExclusions);
      if (payerReady) {
        return true;
      } else {
        return false;
      }
    },
    totalPrice() {
      return this.selectedCar.price;
    },
    fees() {
      return FeesData;
    },
    seasonFare() {
      let pickupTime = this.searchParameters.pickupTime;
      let dropoffTime = this.searchParameters.dropoffTime;
      let currentYear = pickupTime.year();

      let startYear = pickupTime.month() <= 0 ? currentYear - 1 : currentYear;
      let endYear = startYear + 1;

      let seasonStart = moment(`12-09-${startYear}`, "MM-DD-YYYY");
      let seasonEnd = moment(`01-12-${endYear}`, "MM-DD-YYYY");

      return (
        pickupTime.isBetween(seasonStart, seasonEnd, "day", "[]") ||
        dropoffTime.isBetween(seasonStart, seasonEnd, "day", "[]")
      );
    },
    onewayFee() {
      let fee = this.fees.oneWayDropOffFee;
      if (this.seasonFare) {
        fee = 1900;
      }
      const bakkies = ["N1", "H", "J"];
      if (bakkies.includes(this.selectedCar.group)) {
        fee = 2800;
      }
      return this.oneway ? fee : 0;
    },
    onewayFeePrompt() {
      let fee = this.fees.oneWayDropOffFee;
      if (this.seasonFare) {
        fee = 1900;
      }
      const bakkies = ["N1", "H", "J"];
      if (bakkies.includes(this.selectedCar.group)) {
        fee = 2800;
      }
      return fee.toString();
    },
    alreadyAdditionalDriver() {
      if (this.selectedCar.totalExtras.includes("additionalDriver")) {
        return true;
      }
      return false;
    },
    stepBlock() {
      return this.block - 1;
    },
    countrycodes: function () {
      return CountryCodes;
    },
    blockHeading: function () {
      switch (this.block) {
        case 1:
          return "Step 1: Who is driving?";
        case 2:
          return "Step 2: Who is paying?";
        case 3:
          return "Step 3: Add additional driver?";
        case 4:
          return "Step 4: Payment options";
        case 5:
          return "Error";
        default:
          return "Details";
      }
    },

    driverId() {
      return this.driver.idNumber;
    },

    firstAdditionalDriverId() {
      return this.first_additional_driver.idNumber;
    },

    secondAdditionalDriverId() {
      return this.second_additional_driver.idNumber;
    },

    dobState() {
      if (this.driver.idType == "id") {
        return true;
      }

      return false;
    },
    focusedDate() {
      const today = new Date();
      return new Date(today.getFullYear() - 18, today.getMonth(), today.getDate());
    },
    isSecondAdditionalDriver() {
      if (this.$store.state.selectedCar.totalExtras.includes("additionalDriver")) {
        this.first_additional_driver.selected = true;

        return true;
      }

      return false;
    },
    standardExcludedProps() {
      return {
        mileagePrice: this.selectedCar.mileagePrice,
        excessAmount: this.getExcessAmount(
          this.selectedCar.group,
          this.selectedCar.rateType
        ),
      };
    },
    superExcludedProps() {
      return {
        excessAmount: this.getExcessAmount(
          this.selectedCar.group,
          this.selectedCar.rateType
        ),
      };
    },
    getRateTypeWithMileage() {
      const rateType = this.selectedCar.rateType;
      if (rateType === 'Standard') {
        return 'Standard (200km per day)';
      } else if (rateType === 'Super' || rateType === 'Express Lane') {
        return `${rateType} (unlimited mileage)`;
      }
      return rateType;
    },
    formatPickupDate() {
      return this.searchParameters.pickupTime ? 
        this.searchParameters.pickupTime.format('DD MMM YYYY') : '';
    },
    formatPickupTime() {
      return this.searchParameters.pickupTime ? 
        this.searchParameters.pickupTime.format('HH:mm') : '';
    },
    formatDropoffDate() {
      return this.searchParameters.dropoffTime ? 
        this.searchParameters.dropoffTime.format('DD MMM YYYY') : '';
    },
    formatDropoffTime() {
      return this.searchParameters.dropoffTime ? 
        this.searchParameters.dropoffTime.format('HH:mm') : '';
    },
    formatPickupLocation() {
      if (!this.searchParameters.pickupLocation) return '';
      const location = this.searchParameters.pickupLocation.locationName;
      // Extract the main location name (e.g., "Cape Town International" from full address)
      const parts = location.split(',');
      return parts[0].trim();
    },
    formatDropoffLocation() {
      if (!this.searchParameters.dropoffLocation) return '';
      const location = this.searchParameters.dropoffLocation.locationName;
      // Extract the main location name (e.g., "Durban City" from full address)
      const parts = location.split(',');
      return parts[0].trim();
    },
  },
  beforeRouteLeave (to, from, next) {
    this.saveDataToStore().then(() => {
      next(); // proceed to the next route after saving data
    }).catch(error => {
      // handle error, possibly stay on the same page or show a message
      console.error("Failed to save data", error);
      next(false); // prevent navigation
    });
  },
  components: {
    ClipLoader,
    CustomDetailsSelect,
    CustomDetailsInput,
    CustomDetailsDatepicker,
    inclusionsModal,
    rentalConditionsModal,
    FailureCard,
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/settings.scss";

.booking-time-error {
  margin: 0px 16px 16px 16px;
}

.visa-logo {
  margin-top: 24px;
  margin-bottom: 24px;
  img {
    width: 80px;
    margin-top: 0.75em;
    margin-bottom: 0.75em;
  }
  display: flex;
  flex-direction: column;
  width: 100%;
  font-size: 0.8em;
  gap: 0.5em;
}

@media (max-width: 781px) {
  .multiline-fix {
    margin-bottom: 0.75em !important;
    * {
      margin-right: 0 !important;
      width: 100% !important;
    }
    flex-wrap: wrap;
  }
  .mobile-flex-column {
    .control-label {
      display: flex !important;
      flex-direction: column !important;
      align-items: flex-start !important;
    }
  }
}

.fa,
.far,
.fas {
  font-family: "Font Awesome 5 Free" !important;
}

.redeem-heading {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 28px;
  display: flex;
  align-items: center;
  letter-spacing: 0.01em;
  color: #30384a;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.how-it-works {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  /* identical to box height, or 143% */

  letter-spacing: 0.01em;
  text-decoration-line: underline;

  /* color/sys/light/text/lvl-1 */

  color: #30384a;
  cursor: pointer;
}

.steps {
  width: 100%;
  grid-area: steps;
}

.pair {
  display: block;
  margin-bottom: 8px;
}

.key {
  text-align: left;
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */

  display: inline;
  letter-spacing: 0.01em;
  margin-right: 4px;

  color: #000000;
}

.value {
  opacity: 1;
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */

  display: inline;
  letter-spacing: 0.01em;

  color: #000000;
}

.totals {
  opacity: 1;
  font-weight: bold;
}

.value-nowrap {
  white-space: nowrap;
}

.pair-flex {
  display: flex !important;
  justify-content: space-between;
  align-items: center;
}

.value-right {
  display: flex !important;
  text-align: right;
}

.pair-flex {
  display: flex !important;
  justify-content: space-between;
  align-items: center;
}

.value-right {
  display: flex !important;
  text-align: right;
  float: none !important;
}

.mobile-only {
  display: flex;
}

.custom-button {
  border-radius: 104px !important;
  font-family: "Inter" !important;
  font-style: normal;
  font-weight: 500 !important;
  font-size: 16px !important;
  line-height: 24px !important;
  /* identical to box height, or 150% */

  display: flex;
  align-items: center;
  text-align: center;
  letter-spacing: 0.01em !important;

  /* color/sys/light/text/contrast */
}

.margin-bottom-small {
  margin-bottom: 0.75em !important;
}

.margin-bottom {
  margin-bottom: 1.5em !important;
}

#loading {
  margin: auto;
  padding: 2em 5em;
  padding-bottom: 1em;
  border-radius: 8px;
  display: flex;
  max-width: 350px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .heading {
    margin-top: 0.75em;
    font-family: "Helvetica Neue";
    font-size: 1.6em;
    font-weight: bold;
    white-space: nowrap;
  }
}

.redeem-notice {
  font-size: 0.8em;
  color: darken($grey, 30%);
  margin-bottom: 0.75em;
}

.is-danger {
  color: #ff3860 !important;
}

.no-wrap {
  white-space: nowrap;
}

.dev-only {
  padding: 0.4em;
  margin: 15px 0;
  width: fit-content !important;
  cursor: pointer;
  font-size: 14px;
  border: 1px solid black;
  background: lightcoral;
  border-radius: 6px;
  color: white;
}

.rotate-in-enter-active {
  animation: slide-in-left-less 0.15s cubic-bezier(1, 0.5, 0.8, 1) both;
}

.passenger-type {
  width: fit-content;
  margin-bottom: 1em;
}

#details {
  border-radius: 8px;
  z-index: 100;
}

.container-div {
  max-width: inherit;
  display: flex;
}

form {
  width: 100%;
}

form,
#details {
  gap: 16px;
  text-align: left;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  max-width: 750px;
  z-index: 10;
  .booking-button {
    padding: 0.4em;
    border: 1px solid $primary-dark;
    background: $primary-color;
    border-radius: 6px;
    cursor: pointer;
    color: white;
    .booking-prompt {
      color: white !important;
    }
  }
}
.block-navigation-wrapper {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
  padding: 24px 12px;
}
.block-navigation {
  background: none;
  div {
    width: auto;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
  }
}

.block-heading {
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 24px;
  /* identical to box height, or 171% */

  display: flex;
  align-items: center;
  letter-spacing: 0.2em;
  text-transform: uppercase;

  /* color/ref/navy/900 */

  color: #30384a;
}

.block-heading-2 {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */

  display: flex;
  align-items: center;
  letter-spacing: 0.01em;

  color: #000000;
}

@media (max-width: 781px) {
  form {
    margin-top: 20px;
  }

  .max-w-120 {
    max-width: none;
  }

  .max-w-180 {
    max-width: none;
  }
}

.next {
  width: 200px;
  height: 44px;
  background-color: #30384a;
  color: white !important;
  align-items: center;
  display: flex;
  justify-content: center;
  span {
    color: white !important;
  }
  div {
    height: 100%;
    width: 100%;
    span {
      color: white !important;
    }
  }
}

.back {
  div {
    display: flex;
    align-items: center;
    span {
      color: $brandBlue;
      margin-left: 1rem;
    }
  }
}

.form-errors {
  align-self: flex-start;
  width: 100%;
  min-width: 280px;
  grid-area: errors;
  background: #ffffff;
  border-top: 4px solid #be7d2d;
  padding: 32px;
  box-sizing: border-box;
  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.05);
  border-radius: 12px;
  margin: 0;
  z-index: 10;
}

.block-contents {
  padding: 16px;
}

@media (min-width: 781px) {
  #details {
    background: none;
    border: none;
    box-shadow: none;
    display: grid;
    max-width: 1100px;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-template-rows: auto;
    grid-column-gap: 1em;
    grid-template-areas: "form form form errors";
  }

  .half-field {
    width: 49%;
  }

  .block-navigation-wrapper {
    display: flex;
    align-items: center;
    width: 100%;
  }
  .next {
    width: 200px;
    height: 44px;
    background-color: #30384a;
    color: white;
    div {
      height: 100%;
      width: 100%;
      span {
        color: white;
      }
    }
  }

  .back {
    div {
      display: flex;
      align-items: center;
      span {
        color: $brandBlue;
        margin-left: 1rem;
      }
    }
  }
  .multiline-fix {
    flex-wrap: nowrap !important;
  }
  .is-column {
    flex-direction: column;
  }
  form {
    min-width: 400px;
    grid-area: form;
    background: #ffffff;
    /* shadow/light/container/default */
    box-shadow: 0px -1px 4px rgba(0, 0, 0, 0.05), 0px 2px 8px -2px rgba(0, 0, 0, 0.1);
    border-radius: 12px;
    margin-top: 0;
  }

  .block-contents {
    padding: 32px;
  }

  .underlined {
    text-decoration: underline;
  }
}
// Mobile styles
@media (max-width: 780px) {
  form {
    background-color: #ffffff;
    width: 100%;
    min-width: 280px;
    padding: 16px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.05);
    box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.05);
    border-radius: 12px;
  }
  .block-navigation-wrapper {
    padding-bottom: 0;
    max-width: 100%;
  }
  .mobile-only {
    display: block;
  }
  .custom-button {
    width: 100%;
    margin-top: 32px;
  }
  .title-and-initials,
  .id-and-id-type {
    display: flex;
    flex-direction: row;
    gap: 16px;

    div.custom-select,
    div.custom-input {
      flex: 1; // This will let both children flex equally
      min-width: 0; // This is to prevent any overflowing content from expanding the box
    }

    div.custom-select div.selected-option {
      width: auto; // Let's use auto for now. Adjust as necessary.
    }
  }
  .day-and-month-of-birth {
    display: flex;
    flex-direction: column;
    gap: 16px;

    div.custom-select,
    div.custom-input {
      flex: 1; // This will let both children flex equally
      min-width: 0; // This is to prevent any overflowing content from expanding the box
      width: 100%;
    }

    div.custom-select div.selected-option {
      width: 100%; // Let's use auto for now. Adjust as necessary.
    }

    div.custom-select.max-w-180,
    .max-w-180 {
      max-width: 100%;
    }
  }
}
</style>

<style lang="scss">
// Globl modal styles
.modal-background {
  background: #f0efed !important;
}
.modal-content {
  background: none !important;
  box-shadow: none !important;
}
ul {
  list-style: none;
}

.step-items {
  list-style: none !important;
}

.control .help.counter {
  display: none !important;
}

.square-list {
  font-family: "Inter";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  /* or 150% */

  letter-spacing: 0.01em;

  /* color/sys/light/text/lvl-3 */

  color: #5b626f;
}

.message-body {
  border-radius: 0;
  background: #d7d9db;
  font-family: "Inter", sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 150%;
  color: #02214d;
}

.label {
  opacity: 0.8 !important;
  font-size: 14px !important;
}

.step-content {
  padding: 0 !important;
}

.breakdown-heading {
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 24px;
  /* identical to box height, or 171% */

  letter-spacing: 0.2em;
  text-transform: uppercase;

  /* color/sys/light/text/lvl-1 */

  color: #30384a;
}

.mt-24 {
  margin-top: 24px;
}
.mt-16 {
  margin-top: 16px;
}

.mr-8 {
  margin-right: 8px;
}

.text-bold {
  font-weight: 600 !important;
}

.flex-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.gap-25 {
  gap: 25px;
}

.max-w-120 {
  max-width: 120px;
}

.max-w-180 {
  max-width: 180px;
}
.select.is-fullwidth select {
  background: white !important;
  border-radius: 2px !important;
}

.textarea,
.input,
.taginput .taginput-container.is-focusable {
  border-radius: 2px !important;
}

.prompt-loader {
  margin-top: 3rem;
}

.prompt-header {
  font-size: 1em;
  text-align: center;
  color: #555555;
  margin-top: 1rem;
  padding: 1rem;
  span {
    font-size: 1.2em;
    font-style: normal;
    font-weight: bold;
    color: #555555;
    line-height: 1.6em;
  }
}

@media (max-width: 781px) {
  .label {
    font-size: 10px !important;
  }
  .mobile-flex-column {
    .control-label {
      display: flex !important;
      flex-direction: column !important;
      align-items: flex-start !important;
    }
  }
  .flex-row {
    flex-wrap: wrap;
  }
}

@media (min-width: 781px) {
  .field-max {
    max-width: 200px !important;
  }
  .limit-select {
    max-height: 250px !important;
  }
  .maxed-28 {
    max-width: 28%;
  }
}

input[type="checkbox"] {
  -webkit-appearance: none;
  appearance: none;
  border: 2px solid rgba(135, 139, 149, 1);
  transform: scale(0.8); /* scale down the size */
  border-radius: 4px;
  position: relative;
}

input[type="checkbox"]:checked {
  border-color: #30384a;
}

/* Create a custom check mark */
input[type="checkbox"]::before {
  content: "";
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  height: 12px;
  width: 12px;
  border-radius: 2px;
  background-color: transparent;
}

/* Change the color of the check mark when the checkbox is checked */
input[type="checkbox"]:checked::before {
  background-color: #30384a;
  border-color: #30384a;
}

.checkbox-row input {
  height: 24px;
  width: 24px;
}

.checkbox-row {
  display: flex !important;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
}

.details-segment {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 16px !important;
  line-height: 24px !important;
  /* identical to box height, or 150% */

  display: flex;
  align-items: center;
  letter-spacing: 0.01em !important;

  color: #000000 !important;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.block-divider {
  height: 2px;
  width: 100%;
  background: #ecece9;
}

.block-navigation-button {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px 16px;
  gap: 8px;

  background: #d1d2d6;
  color: #878b95;
  border: 2px solid #b9bcc2;
  border-radius: 20px;
}

.block-navigation-button:hover {
  background: hsl(222, 21%, 28%);
  color: #ffffff;
}

.button-ready {
  background: #30384a !important;
  color: white !important;
}

.block-navigation-back {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
}

.is-error {
  box-shadow: 0px 0px 0px 1px red !important;
}

.is-errorr:after {
  width: 100%;
  height: 100%;
  border: 5px solid red;
}

.redeem-divider {
  height: 2px;
  width: 100%;
  background: #30384a;
}

.review-divider {
  height: 1px;
  width: 100%;
  background: #ecece9;
  margin-top: 8px;
  margin-bottom: 8px;
}

.is-color {
  color: #30384a !important;
}

.redeem-description {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  /* or 150% */

  display: flex;
  align-items: flex-end;
  letter-spacing: 0.01em;

  /* color/sys/light/text/lvl-1 */

  color: #30384a;
}

.flex-col {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
}

.terms-and-conditions {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  /* identical to box height, or 150% */

  display: flex;
  align-items: center;
  letter-spacing: 0.01em;

  /* color/sys/light/text/lvl-1 */

  color: #30384a;
}

.vc-grid-container {
  padding: 16px;
}

.vc-popover-content {
  display: flex;
  gap: 16px;
}

.vc-day-popover-row {
  margin-bottom: 16px;
}

.vc-text-white {
  background: white !important;
}

.modal .modal-content {
  margin: 0 !important;
}

.error-label {
  line-height: 2.5em;
  font-size: 0.8em;
  color: red;
  font-style: italic;
}

.booking-time-error .message-body {
  background: transparent !important;
}

.back-to-search-button {
  background-color: #fff !important;
  color: #30384A !important;
  border: 2px solid #30384A !important;
  border-radius: 104px !important;
  width: 100%; font-style: normal;
  font-weight: 500 !important;
  font-size: 16px !important;
  line-height: 24px !important;
  padding: 8px 16px !important;
}

.back-to-search-button:hover {
  background-color: #30384A !important;
  color: #fff !important;
}

</style>
